import { addMonths, startOfMonth, subMonths } from 'date-fns';
import { rangeRight, range } from 'lodash-es';

// including current month
export function getLastXMonths(now, num) {
  const startOfThisMonth = startOfMonth(now);
  return rangeRight(num).map(numToSub => subMonths(startOfThisMonth, numToSub));
}

// excluding current month
export const getNextXMonths = (now, num) => {
  const startOfThisMonth = addMonths(startOfMonth(now), 1);
  return range(num).map(numToAdd => addMonths(startOfThisMonth, numToAdd));
};